import { useEffect } from 'react';
import {
  SESSION_STORAGE_KEYS,
  setSessionStorageValue,
  useDidUpdateEffect
} from '@namespace/helpers';
import { useLocation } from '@namespace/i18n';
import { useHistory, useSearchParams } from '@namespace/router';
import { PLEX_LIMIT } from '../../../constants';
import { useGetPlatformForFeed } from '../../useGetPlatformForFeed';

export const usePlexPaginationResetPage = ({
  isNotAllowedToReset,
  pageSize,
  games = []
}) => {
  const { replace } = useHistory();
  const { page } = useSearchParams();
  const { pathname, langFromPath } = useLocation();
  const platform = useGetPlatformForFeed();
  const limitExceeded = page * pageSize > PLEX_LIMIT;

  const resetPagePagination = () => {
    setSessionStorageValue(SESSION_STORAGE_KEYS.CASINO_PREV_PAGE_SCROLL_TOP, 0);

    replace(`${pathname}?page=1`);
  };

  // redirect to first page if no pagination data (games) & page > pagesLimit
  const resetPage = () => {
    if (isNotAllowedToReset) {
      return;
    }
    if (limitExceeded && !games.length) {
      resetPagePagination();
    }
  };

  useDidUpdateEffect(() => {
    if (!isNotAllowedToReset && limitExceeded) {
      resetPagePagination();
    }
  }, [platform, langFromPath]); // Language in the URL must change first; only after that can the "page" be changed.

  useEffect(() => {
    resetPage();
  }, [isNotAllowedToReset]);
};
